<template>
  <div>
    <el-row>
      <NewTableContainer
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        ref="TableContainer"
      >
        <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加党组织</el-button>
          </router-link>
        </template>

        <template v-slot:filter>
        </template>

        <!--  -->
        <template v-slot:table__footer__info>党组织列表</template>
      </NewTableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>

<script>

import { NewTableContainer } from "@/core/table/";

export default {
  name: "party-org",
  components: {
    NewTableContainer
  },
  data() {
    return {
      /* 配置块 */
      // table 头
      containerTableColumns: [
        {
          prop: "title",
          label: "组织名",
          width: "330px"
        },
        {
          prop: "pname",
          label: "上级组织"
        }
        
      ],
      // 基础地址
      containerBaseUrl : "/standard/partyorg",
      // api的基础地址
      containerServerUrl :  "/api/manager/partyorg",
      // table config 设置
      tableToolConfig : {
        canEdit: true,
        canRecover: true,
        canDelete: true,
        canDisable: true
      }
    }
  },
  created(){

  }
}



</script>



<style scoped>
</style>